export default __webpack_public_path__ + "static/media/multiCapfundCardBanner.ce650bcb.png";